
<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title" >언어훈련<div class="sub_title" >학습관리 → 숙제관리 → 언어훈련 </div></h5>
        <h6 style="text-align:left; margin-top:10px; ">
        조회하고자 하는 클래스 및 기타 정보를 통해 학습현황을 조회할 수 있습니다.<br />
        학생리스트가 많을수록 조회시간이 길어질 수 있습니다.
      </h6>
      <query-grid :config="config" ref="qg">
        <template #actions>
          <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" @click="Getclasslist(true)">언어훈련관 숙제부여</button>
        </template>
        <template #resultactions>
        <button class="btn btn-secondary" @click="batchDelete()">일괄 Delete</button>
        </template>
        <template #items="props">
          <tr v-for="(record, i) in props.records" v-bind:key="record.intHWNo">
            <td scope="col"><input type="checkbox" v-model="record.checked"></td>
            <td style="text-align:center;" v-if="this.$root.guiPerm != 'CLASS' && this.$root.guiPerm != 'ENTERPRISE'" >
                <Business v-if="record.t2" :biz="record.t2" /></td>
            <td style="text-align:center;"> <Business v-if="record.t1" :biz="record.t1" /></td>

            <td style="text-align:center;">{{ record.username }}</td>
            <td style="text-align:center;">{{ record.name }}</td>
            <td style="text-align:center;">{{ record.datAssign.substr(2, 8) }}</td>
            <td style="text-align:center;">{{ record.datEnd.substr(2, 8) }}</td>
            <td style="text-align:center;">{{ record.strStudyType }}</td>
              <td style="text-align:center;">{{ record.strSection }}</td>
              <td style="text-align:center;">{{ record.strActNo }}</td>
              <td style="text-align:center;">{{ record.strActTitle }}</td>
              <td style="text-align:center;">
                  <a target="_blank" :href="'https://bizstudy.useschool.co.kr/report/report_detail.asp?hno=' + record.intHNo" v-if="record.chrDone"><button class="btn btn-secondary btn-sm">View</button></a>
              </td>
              <td style="text-align:center;">
                <template v-if="record.chrDone">
                  <button class="btn btn-info btn-sm" style="line-height:14px;">Complete<br /><span style="font-size:11px;">{{record.datDone.substr(0, 16)}}</span></button>
                </template>
                <template v-else>
                  <button class="btn btn-danger btn-sm" @click="DelCurrent(record.intHWNo)">Delete</button>
                </template>
              </td>
          </tr>
        </template>
      </query-grid>


<!-- 언어훈련관 숙제부여 modal -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">언어훈련관 숙제부여</h5>
            </div>
            <div class="modal-body">

           <table class="table">
               <colgroup>
               <col style="width:25%;">
                   <col style="width:25%;">
                   <col style="width:25%;">
                   <col style="width:25%;">
               </colgroup>
               <tr>
                 <th>숙제부여</th>
                 <td colspan="3" style="text-align:left;">


                      <select v-model="classselected" class="custom-select flex_center" style="width:170px;display:inline; margin:0 4px;  background:#f0fbff;" @change="viewStudent()">
                          <option disabled value="">Please select one</option>
                          <option v-for="classlist in classlists" :value="classlist.id">
                            {{ classlist.name }}
                          </option>
                        </select>
                        <select v-model="customValue" class="custom-select flex_center" style="width:100px;display:none;">
                          <option :value="0">ALL</option>
                          <option :value="1">개인별</option>
                        </select>
                        <input type="checkbox"
                                v-model="sallChecked"
                                @click="scheckedAll($event.target.checked)"
                        > 전체선택


                 </td>
                  <td>
                    <button class="btn btn-warning btn-sm" style="visibility:hidden;">GUIDE</button>
                    <button class="btn btn-info btn-sm" style="visibility:hidden;">FIND ACTIVITY</button>
                  </td>
                </tr>
              </table>
              <!-- 개인별 선택시 -->
              <p>
                숙제부여 대상(개인별 부여)
              </p>

              <div class="select_homework">
                <ul v-if="customValue == '1'">
                <li v-for="(studentlist, index) in studentlists" :value="studentlist.id">
                      <input type="checkbox" name='tmpChkbox[]' :value="index" style="vertical-align:top;" v-model="studentlist.selected" @change="selected($event)"/>{{studentlist.name}}&nbsp;
                  </li>
                </ul>
              </div>
              <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg" >시작일</td>
                      <td style="text-align:left;">  <input v-model="datAssign" Type="date" style="width:140px; height:40px;text-align:center; vertical-align:middle; border:1px solid #ccc; margin:0 2px; border-radius:4px;" /></td>
                      <td class="th_bg">종료일</td>
                      <td style="text-align:left;">  <input v-model="datEnd" Type="date" style="width:140px; height:40px;text-align:center; vertical-align:middle; border:1px solid #ccc; margin:0 2px; border-radius:4px;" /></td>
                    </tr>
                    <tr>
                      <td class="th_bg" >부여할 학습 </td>
                        <td colspan="3" style="text-align:left;"><input v-model="ActivityValue" type="text" style="width:140px; text-align:center; height:40px; vertical-align:middle; border:1px solid #ccc; margin:0 2px; border-radius:4px;" /><button class="btn btn-primary " v-on:click="onAct()">적용</button>
                          <button class="btn btn-success" onclick="window.open('https://bizstudy.useschool.co.kr/UbestA/ubesta2_new/curriculum/language_course_lms.asp','학습번호 찾기','width=900,height=500,location=no,status=no,scrollbars=yes');">학습번호 찾기</button>
                    </td>
                    </tr>

                  </tbody>
                </table>
              <table class="table" v-if="ActivityList != ''">
      <thead>
      <tr>
        <td>Activity No</td>
        <td>Title</td>
        <td>Type</td>
        <td>Step</td>
        <td><input type="checkbox"
                                v-model="allChecked"
                                @click="checkedAll($event.target.checked)"
                        >Choose</td>
        <td>Section</td>
      </tr>
      </thead>
      <tbody>
        <tr>
    <td rowspan="17" style="background:#f8f8e1;">{{ActivityList.ACTIVITY_NO}}</td>
    <td rowspan="17" style="background:#fffffb;">{{ActivityList.ActTitle}}</td>
    <td rowspan="4" style="background:#f8f8f8;">Word Speaking</td>
    <template v-if="ActivityList.WS_LIS">
      <td>Listen</td>
      <td><input v-model="selData.WS_LIS_C" type="checkbox" name="HW_type[]" value="WS_LIS"></td>
      <td>
        <select v-model="selData.WS_LIS_S" id="WS_LIS_S">
          <option v-for="section in ActivityList.WS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Listen</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.WS_SHA">
      <td>Shadowing</td>
      <td><input v-model="selData.WS_SHA_C" type="checkbox" name="HW_type[]" value="WS_SHA"></td>
      <td>
        <select v-model="selData.WS_SHA_S" id="WS_SHA_S">
          <option v-for="section in ActivityList.WS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Listen</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.WS_PRE">
      <td>Pretest</td>
      <td><input v-model="selData.WS_PRE_C" type="checkbox" name="HW_type[]" value="WS_PRE"></td>
      <td>
        <select v-model="selData.WS_PRE_S" id="WS_PRE_S">
          <option v-for="section in ActivityList.WS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Pretest</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.WS_TEST">
      <td>Test</td>
      <td><input v-model="selData.WS_TEST_C" type="checkbox" name="HW_type[]" value="WS_TEST"></td>
      <td>
        <select v-model="selData.WS_TEST_S" id="WS_TEST_S">
          <option v-for="section in ActivityList.WS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Test</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <td rowspan="4" style="background:#f8f8f8;">Word Writing</td>
    <template v-if="ActivityList.WW_PRA">
      <td>Practice</td>
      <td><input v-model="selData.WW_PRA_C" type="checkbox" name="HW_type[]" value="WW_PRA"></td>
      <td>
        <select v-model="selData.WW_PRA_S" id="WW_PRA_S">
          <option v-for="section in ActivityList.WW_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Practice</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.WW_QUIZ">
      <td>Quiz</td>
      <td><input v-model="selData.WW_QUIZ_C" type="checkbox" name="HW_type[]" value="WW_QUIZ"></td>
      <td>
        <select v-model="selData.WW_QUIZ_S" id="WW_QUIZ_S">
          <option v-for="section in ActivityList.WW_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Quiz</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.WW_PRE">
      <td>Pretest</td>
      <td><input v-model="selData.WW_PRE_C" type="checkbox" name="HW_type[]" value="WW_PRE"></td>
      <td>
        <select v-model="selData.WW_PRE_S" id="WW_PRE_S">
          <option v-for="section in ActivityList.WW_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Pretest</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.WW_TEST">
      <td>Test</td>
      <td><input v-model="selData.WW_TEST_C" type="checkbox" name="HW_type[]" value="WW_TEST"></td>
      <td>
        <select v-model="selData.WW_TEST_S" id="WW_TEST_S">
          <option v-for="section in ActivityList.WW_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Pretest</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
  <td rowspan="4" style="background:#f8f8f8;">Sentence Speaking</td>
    <template v-if="ActivityList.SS_SHA">
      <td>Shadowing</td>
      <td><input v-model="selData.SS_SHA_C" type="checkbox" name="HW_type[]" value="SS_SHA"></td>
      <td>
        <select v-model="selData.SS_SHA_S" id="SS_SHA_S">
          <option v-for="section in ActivityList.SS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Shadowing</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.SS_PRA">
      <td>Practice</td>
      <td><input v-model="selData.SS_PRA_C" type="checkbox" name="HW_type[]" value="SS_PRA"></td>
      <td>
        <select v-model="selData.SS_PRA_S" id="SS_PRA_S">
          <option v-for="section in ActivityList.SS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Practice</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.SS_PRT">
      <td>Presentaion</td>
      <td><input v-model="selData.SS_PRT_C" type="checkbox" name="HW_type[]" value="SS_PRT"></td>
      <td>
        <select v-model="selData.SS_PRT_S" id="SS_PRT_S">
          <option v-for="section in ActivityList.SS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Presentaion</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.SS_TEST">
      <td>Test</td>
      <td><input v-model="selData.SS_TEST_C" type="checkbox" name="HW_type[]" value="SS_TEST"></td>
      <td>
        <select v-model="selData.SS_TEST_S" id="SS_TEST_S">
          <option v-for="section in ActivityList.SS_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Test</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <td rowspan="3" style="background:#f8f8f8;">Sentence Writing</td>
    <template v-if="ActivityList.SW_PRA">
      <td>Practice</td>
      <td><input v-model="selData.SW_PRA_C" type="checkbox" name="HW_type[]" value="SW_PRA"></td>
      <td>
        <select v-model="selData.SW_PRA_S" id="SW_PRA_S">
          <option v-for="section in ActivityList.SW_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Practice</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.SW_QUIZ">
      <td>Quiz</td>
      <td><input v-model="selData.SW_QUIZ_C" type="checkbox" name="HW_type[]" value="SW_QUIZ"></td>
      <td>
        <select v-model="selData.SW_QUIZ_S" id="SW_QUIZ_S">
          <option v-for="section in ActivityList.SW_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Quiz</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.SW_TEST">
      <td>Test</td>
      <td><input v-model="selData.SW_TEST_C" type="checkbox" name="HW_type[]" value="SW_TEST"></td>
      <td>
        <select v-model="selData.SW_TEST_S" id="SW_TEST_S">
          <option v-for="section in ActivityList.SW_S" :value="section">
            {{ section }}
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Test</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <td rowspan="2" style="background:#f8f8f8;">Dubbing</td>
    <template v-if="ActivityList.DU_PRA">
      <td>Practice</td>
      <td><input v-model="selData.DU_PRA_C" type="checkbox" name="HW_type[]" value="DU_PRA"></td>
      <td><select v-model="selData.DU_PRA_S" id="DU_PRA_S">
          <option>
            A
          </option>
        </select>
      </td>
    </template>
    <template v-else>
      <td>Practice</td>
      <td></td>
      <td></td>
    </template>
  </tr>
  <tr>
    <template v-if="ActivityList.QA_TEST">
      <td>Live</td>
      <td><input v-model="selData.QA_TEST_C" type="checkbox" name="HW_type[]" value="QA_TEST"></td>
      <td>&nbsp;</td>
    </template>
    <template v-else>
      <td>Live</td>
      <td></td>
      <td></td>
    </template>
  </tr>

    </tbody>
  </table>


            </div>
            <div class="modal-footer flex_center">
              <button  v-if="ActivityList != ''" class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" @click="PutCurrent(true)">숙제부여</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>

            </div>
        </div>
    </div>
</div>

      </div>
    </div>
  </div>



</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import Student from "../components/detail_pages/Student.vue";
import TreeBtn from "../components/treeBtn";
import axios from "axios";
export default {
  name: 'Home',
  components: {
    Tree,
    TreeBtn,
    Business,
    Student,
    QueryGrid
  },
  mounted(){
    if(this.$root.guiPerm == 'CLASS' || this.$root.guiPerm == 'ENTERPRISE'){
        this.config.columns.splice(1, 1);
      }
    //if(this.$root.guiPerm !== 'ROOT'){
      this.$refs.qg.search()
    //}
    if (this.$route.query.id) {

        (new bootstrap.Modal(document.getElementById("modifySubscriptionModal"))).show();
        this.getDetailSubscription({
          id: this.$route.query.id
        });
      }
      if (this.$route.query.new) {
        (new bootstrap.Modal(document.getElementById("buyProductModal"))).show();
        this.selStudent = {
          id: this.$route.query.student
        }
      }
  },
  methods: {
                  toggleAllChecks(){
            var to = null;
            var status = this.getAllCheckStatus();
            if(status <= 0){
              to = true;
            } else {
              to = false;
            }
            this.updateAllChecks(to);
          },
        updateAllChecks(status){
          this.records.filter(v => !v.chrDone).forEach((v) => {
            v.checked = !!status;
          })
        },
                getAllCheckStatus(){
          var checks = this.records.filter(v => !v.chrDone).map(x => x.checked || false);
          console.log(checks)
          if(!checks.includes(true)){
            console.log(-1)
            return -1;
          } else if(!checks.includes(false)) {
            console.log(1)
            return 1;
          } else {
            console.log(0)
            return 0;
          }
        },
      selectedSearchBiz(biz) {
      //console.log(biz)
      this.searchBiz = biz;
      this.$refs.qg.search()
    },
    batchDelete(){
      var prom = [];
      this.$refs.qg.checked.forEach(element => {
        //if(element.checked){
          prom.push(this.DelCurrent(element.intHWNo, true));
        //}
      });
      Promise.all(prom).then(() => {
        this.$refs.qg.search()
      })
    },
    search(reset){
      if(reset) this.offset=0;
      var extras = "?limit=15&offset=" + this.offset
      if(this.searchBiz && this.searchBiz.length){
        extras += "&business=" + JSON.stringify(this.searchBiz)
      }
      if(this.searchKeyword){
        extras += "&search=" + this.searchKeyword
      }
      if(this.searchActiviy){
        extras += "&strActNo=" + this.searchActiviy
      }
      if(this.date_filter){
        extras += "&date_filter=" + this.date_filter
        if(this.date_filter_start){
          extras += "&date_filter_start=" + this.date_filter_start
        }
        if(this.date_filter_end){
          extras += "&date_filter_end=" + this.date_filter_end
        }
      }
      if(this.sStatus){
        extras += "&sStatus=" + this.sStatus
      }
      if(this.sType){
        extras += "&sType=" + this.sType
      }
      axios.get('/studies/HomeList' + extras).then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            this.records = response.data.result;
            this.total = response.data.total;
            console.log(this.records);
          }
        })
    },
    Getclasslist(reset){

      axios.get('/homework/languages_add').then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            this.classlists = response.data.classlist;
            this.ActivityList = "";
            this.selData = {};
          }
        })
    },
    GetDetail(intHWNo, b1){
      //console.log(intHWNo);
      axios.get(this.$root.baseUrl + '/homework/languages_detail/' + intHWNo, {
            headers: {
                "Authorization": "Bearer " + this.$root.accessToken
            }
        }).then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            console.log(response.data.slist);
            this.details = response.data.result;
            this.students = response.data.slist;
            this.sb1 = b1;
          }
        })
    },
    viewStudent(){
      //console.log(this.classselected);
      axios.get('/homework/students/' + this.classselected).then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            this.studentlists = response.data.result;
            this.stotal = response.data.total;
            this.sallChecked = false;
          }


        })
    },
    onAct(){
      axios.get('/homework/activity/' + this.ActivityValue).then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else{
            var today = new Date();

            var year = today.getFullYear();
            var month = ('0' + (today.getMonth() + 1)).slice(-2);
            var day = ('0' + today.getDate()).slice(-2);

            var dateString = year + '-' + month  + '-' + day;

            if(!this.datAssign){
              this.datAssign = dateString;
            }

            if(!this.datEnd){
              this.datEnd = dateString;
            }

            this.selData = {};
            this.selData = {
              WS_LIS_S : "A",
              WS_SHA_S : "A",
              WS_PRE_S : "A",
              WS_TEST_S : "A",
              WW_PRA_S : "A",
              WW_QUIZ_S : "A",
              WW_PRE_S : "A",
              WW_TEST_S : "A",
              SS_PRA_S : "A",
              SS_SHA_S : "A",
              SS_PRT_S : "A",
              SS_TEST_S : "A",
              SW_PRA_S : "A",
              SW_QUIZ_S : "A",
              SW_TEST_S : "A",
              DU_PRA_S : "A"
            };
            this.ActivityList = response.data.result;
          }
        })
    },
    checkedAll(checked) {
        this.allChecked = checked;
         $("input[name='HW_type[]']").prop("checked", this.allChecked);
    },
    PutCurrent(reset){

      var intSu = 0;

      if(!this.classselected){
        $.notify({
          // options
          message: '부여할 클래스를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      var tmpVal = [];
      var temStu = [];

      if(this.customValue){

        temStu = this.studentlists;

        $("input[name='tmpChkbox[]']:checked").each(function() {
          tmpVal.push(temStu[$(this).val()].id);
          intSu = intSu + 1;
        });

        if(intSu == 0){
          strmessage = '부여할 학생을 선택하셔야 합니다. '
        }

        //console.log(tmpVal);

        if(!tmpVal){
          $.notify({
            // options
            message: '부여할 학생을 선택하셔야 합니다. '
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
        }

      }

      var actVal = [];
      var secVal = [];

      $("input[name='HW_type[]']:checked").each(function() {
        actVal.push($(this).val());
        secVal.push($(eval($(this).val() + '_S')).val());
      });

      //console.log(tmpVal);
      //return;

      axios.post('/homework/homesave', {
        'classselected': this.classselected,
        'customValue': this.customValue,
        'tmpVal': tmpVal,
        'actVal': actVal,
        'secVal': secVal,
        'ActNo': this.ActivityList.ACTIVITY_NO,
        'ActTitle': this.ActivityList.ActTitle,
        'datAssign': this.datAssign,
        'datEnd': this.datEnd
      }).then((response) => {
        if (response.data.error) {
          $.notify({
            // options
            message: '숙제를 부여 할 수 없습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
        } else {
          console.log(response.data.result);

          $.notify({
              // options
            message: '숙제를 부여하였습니다.'
          }, {
            // settings
            type: 'success',
            z_index: 9999
          });
          this.$refs.qg.search()
        }
      })

    },
    scheckedAll(checked) {
        this.sallChecked = checked;
        for (let i in this.studentlists) {
              this.studentlists[i].selected = this.sallChecked;
          }
    },
    selected (e) {
        for (let i in this.studentlists) {
            if(! this.studentlists[i].selected) {
                this.sallChecked = false;
                return;
            } else {
                this.sallChecked = true;
            }
        }
    },
    DelCurrent(intHWNo, skipSearch) {
      return new Promise(resolve => {
      axios.post('/studies/HomeDelete', {
        'intHWNo': intHWNo
      }).then((response) => {
        resolve()
        if (response.data.error) {
          $.notify({
            // options
            message: '데이터를 삭제할 수 없습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
        } else {
          $.notify({
            // options
            message: '삭제되었습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          if(!skipSearch) this.$refs.qg.search()
        }
      })
      })


    }
  },
  data(){
    return {
      config: {
      "name": "언어훈련관 숙제",
      "req_endpoint": "/studies/HomeList_als",
      "default_limit": 20,
      "search_fields": [
          {
              "id": "businesses",
              "name": "소속선택",
              "type": "business" // business, date, datetime,
          },
          {
              "id": "date_filter",
              "name": "날짜검색",
              "type": "date",
              "filter_type": {
                  "created_at": "시작일",
                  "end_date": "종료일"
              }
          },
          {
              "id": "type_ws_filter",
              "name": "Word Speaking",
              "type": "switch",
              "filter_type": {
                  "WS_LIS": {"name": "Listen", "css": {}},
                  "WS_SHA": "Shadowing",
                  "WS_PRE": "Pretest",
                  "WS_TEST": "Test",
              }
          },
                    {
              "id": "type_ww_filter",
              "name": "Word Writing",
              "type": "switch",
              "filter_type": {
                  "WW_PRA": "Practice",
                  "WW_QUIZ": "Quiz",
                  "WW_PRE": "Pretest",
                  "WW_TEST": "Test",
              }
          },
                    {
              "id": "type_ss_filter",
              "name": "Sentence Speaking",
              "type": "switch",
              "filter_type": {
                  "SS_SHA": "Shadowing",
                  "SS_PRA": "Practice",
                  "SS_PRT": "Presentaion",
                  "SS_TEST": "Test",
              }
          },
                    {
              "id": "type_sw_filter",
              "name": "Sentence Writing",
              "type": "switch",
              "filter_type": {
                  "SW_PRA": "Practice",
                  "SW_QUIZ": "Quiz",
                  "SW_TEST": "Test"
              }
          },
                              {
              "id": "type_etc_filter",
              "name": "기타",
              "type": "switch",
              "filter_type": {
                  "DU_PRA": "Dubbing Practice"
              }
          },
          {
              "id": "status_filter",
              "name": "수행여부",
              "type": "switch",
              "filter_type": {
                  "FINISH": "완료",
                  "ING": "미완료"
              }
          },
          {
              "id": "search_An",
              "name": "Activity No.",
              "type": "text",
              "placeholder": "Activity No 검색"
          },
          {
              "id": "search",
              "name": "Student",
              "type": "text",
              "placeholder": "이름으로 검색"
          }
      ],
      "columns": [
          {
              "id": "chkbox",
              "name": "체크",
              "is_check": true,
              "excel_print": false
          },
          {
              "id": "biz",
              "name": "Campus",
              "excel_print": v=>{return v.t2.name}
          },
          {
              "id": "Class",
              "name": "Class",
              "excel_print": v=>{return v.t1.name}
          },
          {
              "id": "ID",
              "name": "ID",
              "excel_print": v=>{return v.username}
          },
          {
              "id": "Name",
              "name": "Name",
              "excel_print": v=>{return v.name}
          },
          {
              "id": "Assigned Date",
              "name": "Assigned Date",
              "excel_print": v=>{return v.datAssign.substr(2, 8)}
          },
          {
              "id": "Due Date",
              "name": "Due Date",
              "excel_print": v=>{return v.datEnd ? v.datEnd.substr(0, 10) : ''}
          },
          {
              "id": "Type",
              "name": "Type",
              "excel_print": v=>{return v.strStudyType}
          },
          {
              "id": "Section",
              "name": "Section",
              "excel_print": v=>{return v.strSection}
          },
          {
              "id": "Activity No",
              "name": "Activity No",
              "excel_print": v=>{return v.strActNo}
          },
          {
              "id": "Act name",
              "name": "Act name",
              "excel_print": v=>{return v.strActTitle}
          },
          {
              "id": "Detail",
              "name": "Detail",
              "excel_print": false
          },
          {
              "id": "Result",
              "name": "Result",
              "excel_print": v=>{return v.chrDone ? 'Complete' + v.datDone.substr(0, 16) : ''}
          }
      ],
      disable_init_search: true
  },
      records: [],
      searchKeyword: "",
      searchBiz: "",
      sType: "",
      sStatus: "",
      offset: 0,
      total: 0,
      index: 0,
      classlists: [],
      studentlists: [],
      classselected: '',
      customValue: '1',
      stotal: 0,
      ActivityValue: 'LA259',
      ActivityList: [],
      sb1: "",
      details: "",
      students: "",
      sallChecked: false,
      selData: {
      },
      allChecked: false
    }
  },
          computed: {
              checked: function(){
        return this.records.filter(record => record.checked && !record.chrDone);
      }
      }
}
</script>
